import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Settings as SettingsIcon, Shield, Bell, Database } from 'lucide-react';
import { Button } from '../components/Button';
import { toast } from 'sonner';
export default function Settings() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-3809">
      <div className="flex justify-between items-end border-b border-border/50 pb-4" data-id="element-3810">
        <div data-id="element-3811">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground" data-id="element-3812">
            PENGATURAN SISTEM
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-3813">
            Konfigurasi & Preferensi // Parameter Global
          </p>
        </div>
        <div className="flex gap-3" data-id="element-3814">
          <div className="glass-panel px-3 py-1.5 rounded flex items-center gap-2 border-primary/30" data-id="element-3815">
            <span className="relative flex h-2 w-2" data-id="element-3816">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" data-id="element-3817"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" data-id="element-3818"></span>
            </span>
            <span className="text-xs font-mono text-primary tracking-widest" data-id="element-3819">
              SINKRONISASI AKTIF
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3820">
        <Card className="glass-panel-heavy border-l-4 border-l-primary shadow-[0_0_15px_rgba(var(--primary),0.1)]" data-id="element-3821">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-3822">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-3823">
              <Shield className="w-4 h-4 text-primary" data-id="element-3824" /> Keamanan
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 space-y-4" data-id="element-3825">
            <div className="flex justify-between items-center" data-id="element-3826">
              <div data-id="element-3827">
                <p className="text-sm font-medium" data-id="element-3828">Wajibkan MFA</p>
                <p className="text-xs text-muted-foreground" data-id="element-3829">
                  Terapkan otentikasi multi-faktor untuk semua pengguna.
                </p>
              </div>
              <input type="checkbox" defaultChecked className="toggle-checkbox" data-id="element-3830" />
            </div>
            <div className="flex justify-between items-center" data-id="element-3831">
              <div data-id="element-3832">
                <p className="text-sm font-medium" data-id="element-3833">Batas Waktu Sesi</p>
                <p className="text-xs text-muted-foreground" data-id="element-3834">
                  Keluar otomatis untuk pengguna yang tidak aktif.
                </p>
              </div>
              <select className="bg-black/40 border border-border/50 rounded p-1 text-xs focus:outline-none focus:border-primary/50" data-id="element-3835">
                <option data-id="element-3836">15 mnt</option>
                <option data-id="element-3837">30 mnt</option>
                <option data-id="element-3838">1 jam</option>
              </select>
            </div>
          </CardContent>
        </Card>

        <Card className="glass-panel-heavy border-l-4 border-l-primary shadow-[0_0_15px_rgba(var(--primary),0.1)]" data-id="element-3839">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-3840">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-3841">
              <Bell className="w-4 h-4 text-primary" data-id="element-3842" /> Notifikasi
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 space-y-4" data-id="element-3843">
            <div className="flex justify-between items-center" data-id="element-3844">
              <div data-id="element-3845">
                <p className="text-sm font-medium" data-id="element-3846">Peringatan Kritis</p>
                <p className="text-xs text-muted-foreground" data-id="element-3847">
                  Notifikasi push untuk peringatan sistem kritis.
                </p>
              </div>
              <input type="checkbox" defaultChecked className="toggle-checkbox" data-id="element-3848" />
            </div>
            <div className="flex justify-between items-center" data-id="element-3849">
              <div data-id="element-3850">
                <p className="text-sm font-medium" data-id="element-3851">Ringkasan Harian</p>
                <p className="text-xs text-muted-foreground" data-id="element-3852">
                  Terima ringkasan aktivitas sistem setiap hari.
                </p>
              </div>
              <input type="checkbox" className="toggle-checkbox" data-id="element-3853" />
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-3854">
        <Button onClick={() => toast.success('Pengaturan berhasil disimpan.')} className="bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-xs tracking-widest uppercase" data-id="element-3855">
          Simpan Perubahan
        </Button>
      </div>
    </div>;
}